import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bf38f39e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "codesandboxPage" }

import CodeEditor from "@/components/CodeEditor.vue";
import { ref, watchEffect } from "vue";
import {
  executeUsingPost,
  getCodeSandboxLanguageUsingGet,
} from "@/api/codeSandboxController";
// eslint-disable-next-line no-undef
import { Message } from "@arco-design/web-vue";

import CodeSandboxLanguage = API.CodeSandboxLanguage;

export default /*#__PURE__*/_defineComponent({
  __name: 'CodeSandboxPage',
  setup(__props) {

const languageList = ref<CodeSandboxLanguage[]>([]);
const language = ref("java");
const code = ref("");
const theme = ref("vs-dark");

const isRunning = ref<boolean>(false);
const isCollapse = ref<number>(1);
const result = ref({});

const onCodeChange = (value: string) => {
  code.value = value;
};

const getLanguageList = async () => {
  const res = await getCodeSandboxLanguageUsingGet();
  if (res.data.code === 200) {
    languageList.value = res.data.data as any;
  } else {
    Message.error("提交失败，" + res.data.message);
  }
};

const onMockCode = () => {
  languageList.value.forEach((lang) => {
    if (lang.value === language.value) {
      code.value = lang.templateCode as string;
    }
  });
};

const onRunCode = async () => {
  isRunning.value = true;
  result.value = {};
  const res = await executeUsingPost({
    code: code.value,
    language: language.value,
  });
  if (res.data.code === 200) {
    result.value = res.data.data as any;
    isCollapse.value = 1;
    isRunning.value = false;
  } else {
    Message.error("提交失败，" + res.data.message);
  }
};

watchEffect(() => {
  getLanguageList();
});

return (_ctx: any,_cache: any) => {
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_collapse_item = _resolveComponent("a-collapse-item")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_space, { class: "top" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_select, {
          modelValue: language.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
          style: {"margin-bottom":"1vh"},
          bordered: false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageList.value, (item) => {
              return (_openBlock(), _createBlock(_component_a_option, {
                label: item.text,
                value: item.value,
                key: item.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_a_select, {
          modelValue: theme.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((theme).value = $event)),
          style: {"margin-bottom":"1vh"},
          bordered: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_option, {
              label: "vs",
              value: "vs"
            }),
            _createVNode(_component_a_option, {
              label: "vs-dark",
              value: "vs-dark"
            }),
            _createVNode(_component_a_option, {
              label: "hc-dark",
              value: "hc-dark"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_space, { class: "top" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: onMockCode,
          type: "text"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Hello World ")
          ]),
          _: 1
        }),
        false
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: onRunCode,
              type: "outline"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 保存 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_button, {
          onClick: onRunCode,
          loading: isRunning.value,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 运行 ")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(CodeEditor, {
      style: {"width":"70vw","height":"60vh"},
      language: language.value,
      value: code.value,
      theme: theme.value,
      "handle-change": onCodeChange
    }, null, 8, ["language", "value", "theme"]),
    _createVNode(_component_a_collapse, {
      class: "result",
      modelValue: isCollapse.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isCollapse).value = $event)),
      "default-active-key": [1]
    }, {
      default: _withCtx(() => [
        (Object.keys(result.value).length > 0)
          ? (_openBlock(), _createBlock(_component_a_collapse_item, {
              header: `执行结果(退出码：${result.value?.exitCode})`,
              key: "1"
            }, {
              default: _withCtx(() => [
                (result.value.message && result.value.message != '')
                  ? (_openBlock(), _createBlock(_component_a_typography_paragraph, {
                      key: 0,
                      copyable: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(result.value?.message), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})